export const hideEmail = (str: string) => str.replace(/(?!^).(?=.+@)/g, '*');
